module.exports = __webpack_public_path__ + "static/media/19ESCAP6.5099c499.jpg";